
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCenterIec as ObiCenterIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-center-iec.js';
 
 
 

 
 export const ObiCenterIec = createComponent({
   react: React,
   tagName: 'obi-center-iec',
   elementClass: ObiCenterIecElement,
   events: {
     
   }
  });
 
 